import Experience from '../Experience'

export class Mouse {
  constructor() {

    // Resources
    this.experience = new Experience()
    this.sizes = this.experience.sizes

    // Setup
    this.cursor = {
      x: 0,
      y: 0
    }

    this._mousemoveHandler = event => {
      this.cursor.x = event.clientX / this.sizes.width - 0.5
      this.cursor.y = event.clientY / this.sizes.height - 0.5
    }

    window.addEventListener('mousemove', this._mousemoveHandler)
  }

  destroy() {
    window.removeEventListener('mousemove', this._mousemoveHandler)
  }
}
